module.exports = __webpack_public_path__ + "helmet.e1738bc156873f278821.svg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/helmet.svg
// module id = ../../../../../src/assets/img/helmet.svg
// module chunks = main